var waitFor = require("../utils/waitFor");
var posiSession = require("../utils/posi-session");
window.registrationFormCompletedCallback = false;

waitFor(
  "body.part-search-results, body.single-series, body.page-template-qpl",
  function () {
    var posiLogger = require("../utils/event-logger.js")();

    // this variable holds info on the part to continue to
    // after completing the signup form
    var partAfterSignup = false;
    var $downloadButton = $(".traceparts-dl");

    // fullscreen button
    var $fullscreenButton = $(".traceparts-fullscreen");
    function _isFullscreenSupported() {
      return (
        document.fullscreenEnabled ||
        document.webkitFullscreenEnabled ||
        document.mozFullScreenEnabled ||
        document.msFullscreenEnabled
      );
    }

    if (!_isFullscreenSupported()) {
      $fullscreenButton.hide();
    } else {
      $fullscreenButton.click(function (e) {
        e.preventDefault();

        // Do fullscreen
        if ($previewIframe[0].requestFullscreen) {
          $previewIframe[0].requestFullscreen();
        } else if ($previewIframe[0].webkitRequestFullscreen) {
          $previewIframe[0].webkitRequestFullscreen();
        } else if ($previewIframe[0].mozRequestFullScreen) {
          $previewIframe[0].mozRequestFullScreen();
        } else if ($previewIframe[0].msRequestFullscreen) {
          $previewIframe[0].msRequestFullscreen();
        }
      });
    }

    // handle download links
    var registerSubmitted = false;
    $(document).on("click", ".download-3d, .download-2d", function (e) {
      e.preventDefault();

      var $link = $(e.currentTarget);
      var downloadType = $link.hasClass("download-3d")
        ? "download-3d"
        : "download-2d";

      var downloadSource = $link.attr("href");
      if (downloadSource == "#")
        downloadSource = $link.hasClass("traceparts-dl")
          ? "traceparts"
          : "positronic";

      var partNumber = $link.data("part");
      var format = $link.data("format");

      var sessionEmail = posiSession.getSession("tracepartsUserID");
      if (window.POSI_IS_DISTRIBUTOR) {
        sessionEmail = "distributor@connectpositronic.com";
      }

      if (!sessionEmail && downloadType != "download-2d") {
        // trigger session info form

        posiLogger.log({
          event_type: "registration-view",
          part_number: partNumber,
        });

        var userSessionRegistrationModal = $.featherlight(
          ".posi-user-session-form",
          {
            persist: true,
            beforeClose: function () {
              $(".posi-user-session-form")
                .removeClass("featherlight-inner")
                .appendTo("body");
            },
          }
        );

        window.registrationFormCompletedCallback = function (formId) {
          userSessionRegistrationModal.close();

          if (registerSubmitted) return;
          registerSubmitted = true;

          posiLogger.log({
            event_type: "registration-submit",
            part_number: partNumber,
          });

          posiSession.setSession(
            "tracepartsUserID",
            window.posiNewTracepartsUserID
          ); // set my gforms response

          // download when submitted
          if (formId == window.SITE_SETTINGS.userSessionGformID) {
            logAndDownload(partNumber, downloadType, downloadSource, format);
          }
        };

        jQuery(document).on(
          "gform_confirmation_loaded",
          function (event, formId) {
            registrationFormCompletedCallback(formId);
          }
        );
      } else {
        logAndDownload(partNumber, downloadType, downloadSource, format);
      }
    });

    // handle tracepart preview popup
    $(document).on("click", ".traceparts-preview", function (e) {
      e.preventDefault();

      var partNumber = $(e.currentTarget).data("part");
      prepareTracepartsPreview(partNumber);
    });

    var $previewIframe = $(".traceparts-view iframe");
    function prepareTracepartsPreview(partNumber) {
      var $formatSelect = $(".traceparts-view .traceparts-file-format");

      // reset popup state
      $formatSelect.html("<option>Loading...</option>").off("change.download");

      $downloadButton.addClass("button--disabled").data("part", partNumber);

      // add preview iframe
      var embedURL =
        "https://www.traceparts.com/els/" +
        window.SITE_SETTINGS.traceparts.els_id +
        "/en/api/viewer/3d?DisplayLogo=false&SupplierID=" +
        window.SITE_SETTINGS.traceparts.catalog_id +
        "&PartNumber=" +
        encodeURIComponent(partNumber);

      $previewIframe.attr("src", embedURL);

      // get available formats
      $.get({
        url: window.SITE_SETTINGS.ajaxurl,
        data: {
          action: "posi_traceparts_get_formats",
          part_number: partNumber,
        },
        dataType: "json",
        success: function (res) {
          var formatOptions = [];
          $.each(res, function (formatId, formatName) {
            formatOptions.push({
              name: formatName,
              val: formatId,
              option:
                '<option value="' + formatId + '">' + formatName + "</option>",
            });
          });

          formatOptions.sort(function (a, b) {
            return a.name < b.name ? -1 : 1;
          });

          var optionHTML = "";
          $.each(formatOptions, function (i, el) {
            optionHTML += el.option;
          });

          $formatSelect.html(optionHTML);

          $downloadButton.removeClass("button--disabled");

          $formatSelect.on("change.download", function (e) {
            e.preventDefault();

            var selectedFormat = $formatSelect.val();
            $downloadButton.data("format", selectedFormat);
          });

          // set value for default (currently selected) option
          $downloadButton.data("format", formatOptions[0].val);
        },
      });

      $.featherlight($(".traceparts-view"), {
        persist: true,
        beforeClose: function () {
          $(".traceparts-view")
            .removeClass("featherlight-inner")
            .appendTo("body");
        },
      });
    }
    // handle request links
    var loggingAndDownloading = false;
    $(document).on("click", ".request-3d, .request-2d", function (e) {
      e.preventDefault();

      if (loggingAndDownloading) return;
      loggingAndDownloading = true;

      var $link = $(e.currentTarget),
        requestType = $link.hasClass("request-3d")
          ? "request-3d"
          : "request-2d",
        partNumber = $link.data("part");

      logAndDownload(partNumber, requestType);
    });

    function logAndDownload(partNumber, type, source, format) {
      // determine download/request URL
      var requestTypes = ["request-2d", "request-3d"];
      var downloadTypes = ["download-2d", "download-3d"];

      var url = "";
      if (requestTypes.indexOf(type) > -1) {
        // REQUEST
        var dimensionType = type == "request-2d" ? "2d" : "3d";
        url = getRequestURL(partNumber, dimensionType);
      } else if (downloadTypes.indexOf(type) > -1) {
        // DOWNLOAD
        if (source == "positronic") {
          // ...from P+ parts manager
          if (type == "download-2d") {
            url =
              window.SITE_SETTINGS.ppmUrl +
              "/drawing/download-pdf/" +
              encodeURIComponent(partNumber) +
              "?k=" +
              window.partSearchKey;
          } else
            url =
              window.SITE_SETTINGS.ppmUrl +
              "/drawing/download-step/" +
              encodeURIComponent(partNumber) +
              "?k=" +
              window.partSearchKey;
        } else if (source == "traceparts") {
          // ...from TraceParts
          var userID = posiSession.getSession("tracepartsUserID");
          if (window.POSI_IS_DISTRIBUTOR) {
            userID = "distributor@connectpositronic.com";
          }
          if (!userID) {
            return console.error("No Traceparts User ID is set.");
          }

          url =
            window.SITE_SETTINGS.ajaxurl +
            "?action=posi_download_traceparts&part_number=" +
            encodeURIComponent(partNumber) +
            "&format=" +
            format +
            "&tracepartsUserID=" +
            userID;
        } else {
          // direct
          url = source;
        }
      } else {
        console.error("Invalid type passed to logAndDownload: " + type);
        return;
      }

      $downloadButton.text("Downloading...").addClass("button--disabled");

      posiLogger.log(
        {
          event_type: type,
          part_number: partNumber,
        },
        function () {
          setTimeout(function () {
            $downloadButton.text("Download").removeClass("button--disabled");
            loggingAndDownloading = false;
          }, 2000);

          document.location = url;
        }
      );
    }

    function getRequestURL(partNumber, type) {
      return (
        window.SITE_SETTINGS.blogurl +
        "/contact/?request-details=" +
        type +
        "&request-part-number=" +
        encodeURI(partNumber) +
        "#form-request"
      );
    }
  }
);
